export const message = ($instance, msg, type = 'success') => {
  if ($instance.$message) {
    $instance.$message[type](msg);
  } else {
    $instance.$toast(msg);
  }
};

export const confirm = ($instance, msg) => {
  return new Promise((resolve, reject) => {
    if ($instance.$confirm) {
      $instance
        .$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    } else {
      $instance.$dialog
        .confirm({
          title: '提示',
          message: msg,
        })
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    }
  });
};
